import * as THREE from "three";

const _diff = new THREE.Vector3();

// Move position one step toward target at given speed
export function seekToward(
  position: THREE.Vector3,
  target: THREE.Vector3,
  speed: number,
  dt: number,
): THREE.Vector3 {
  _diff.copy(target).sub(position);
  const dist = _diff.length();
  if (dist < 0.01) return position.clone();
  const step = Math.min(dist, speed * dt);
  return position.clone().addScaledVector(_diff.normalize(), step);
}

// Pick a random world position within an annular band around base — used for cover selection
export function coverPosition(
  base: THREE.Vector3,
  spreadMin: number,
  spreadMax: number,
): THREE.Vector3 {
  const angle = Math.random() * Math.PI * 2;
  const radius = spreadMin + Math.random() * (spreadMax - spreadMin);
  return new THREE.Vector3(base.x + Math.cos(angle) * radius, 0, base.z + Math.sin(angle) * radius);
}
